<template>
  <el-dialog
    title="Schedule Video Call Meeting"
    :visible.sync="showModal"
    width="50%">
    <el-form label-width="150px" :model="form" :rules="rules" label-position="left" @reset="onClose" ref="VideoCallForm" class="full-width mb-3">
      <el-steps :active="step" align-center>
        <el-step title="Step 1" description="Schedule"></el-step>
        <el-step title="Step 2" description="Settings"></el-step>
        <el-step title="Step 3" description="Infromation"></el-step>
      </el-steps>
      <hr>
      <div class="p-3">
        <div v-if="step == 0">
          <el-form-item label="Meeting Name">
            <el-input v-model="form.name" placeholder="Please enter meeting name"></el-input>
          </el-form-item>
          <el-form-item label="Assign to">
            <el-select v-model="form.user_id" filterable remote reserve-keyword :remote-method="searchUser"
            placeholder="Please enter a users name" :loading="loading.get_users" style="width: 100%">
              <el-option
                v-for="item in filter_users"
                :key="item.id"
                :label="item.text"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Meeting At">
            <el-date-picker
              v-model="form.meeting_start"
              type="datetime"
              width="100%"
              style="width: 100%"
              placeholder="Plesee select date and time meeting start">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Meeting Duration">
            <el-input type="number" v-model="form.duration" placeholder="Please enter the duration in minutes"></el-input>
          </el-form-item>
          <!-- <el-form-item label="Maximum Participant">
            <el-input type="number" v-model="form.total_participant" placeholder="Please enter total participant of the meeting"></el-input>
          </el-form-item> -->
          <el-form-item label="Additional information">
            <el-input type="textarea" v-model="form.description" placeholder="Please enter description (optional)"></el-input>
          </el-form-item>
          <el-form-item class="float-right">
            <el-button size="small" @click="onClose">Cancel</el-button>
            <el-button size="small" type="primary" @click="validateForm('VideoCallForm')">Next</el-button>
          </el-form-item>
        </div>
        <div v-else-if="step == 1">
          <el-form-item label="Meeting Controls">
            <el-switch
              class="col-12"
              v-model="form.additional_config.voice"
              active-text="Mute Voice"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
            <el-switch
              class="col-12"
              v-model="form.additional_config.camera"
              active-text="Mute Camera"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
            <el-switch
              class="col-12"
              v-model="form.additional_config.share"
              active-text="Share screen"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </el-form-item>
          <el-form-item class="float-right">
            <el-button size="small" @click="() => { step = 0; }">Back</el-button>
            <el-button size="small" type="primary" @click="createVideoCall" :loading="loading.submit">Submit</el-button>
          </el-form-item>
        </div>
        <div v-else-if="step == 2">
          <el-form-item label="Meeting Name">
            <span>{{ form.name }}</span>
          </el-form-item>
          <el-form-item label="Meeting Start">
            <span>{{ moment(form.meeting_start).calendar() }} </span>
          </el-form-item>
          <el-form-item label="Meeting End">
            <span>{{ moment(form.meeting_start).add(form.duration, 'minutes').calendar() }}</span>
          </el-form-item>
          <el-form-item label="Meeting Link">
            <span>{{ form.link }}</span>
          </el-form-item>
          <el-form-item class="float-right">
            <el-button size="small" @click="onClose">Close</el-button>
            <el-button size="small" type="primary" @click="copyLink">Send link</el-button>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import moment from 'moment';
import popupErrorMessages from '@/library/popup-error-messages';
import videoCallAPI from '../../../api/videoCall';
import usersAPI from '../../../api/users';

export default {
  name: 'CreateVideoCall',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    conversation: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  beforeCreate() {
    this.moment = moment;
  },
  data() {
    return {
      loaderStack: 0,
      loader: null,
      showModal: false,
      loading: {
        get_users: false,
        submit: false,
      },
      step: 0,
      filter_users: [],
      rules: {
        name: [
          { required: true, message: 'Please input meeting name', trigger: 'blur' },
        ],
        meeting_start: [
          { required: true, message: 'Please input meeting date', trigger: 'change' },
        ],
        user_id: [
          { required: true, message: 'Please choose user', trigger: 'change' },
        ],
        duration: [
          { min: 1, message: 'Please input meeting duration', trigger: 'blur' },
        ],
        total_participant: [
          { min: 2, message: 'Please input meeting duration', trigger: 'blur' },
        ],
      },
      form: {
        name: '',
        user_id: '',
        duration: 0,
        meeting_start: moment().format('YYYY-MM-DD HH:mm:ss'),
        // contact_id: '',
        total_participant: 2,
        conversation_id: '',
        description: '',
        additional_config: {
          audio: false,
          camera: false,
          share: false,
        },
        link: '',
      },
    };
  },
  watch: {
    show() {
      this.showModal = this.show;
      if (this.show) {
        this.step = 0;
        this.form = {
          name: '',
          user_id: '',
          duration: 0,
          meeting_start: moment().format('YYYY-MM-DD HH:mm:ss'),
          // contact_id: '',
          total_participant: 2,
          conversation_id: '',
          description: '',
          additional_config: {
            audio: false,
            camera: false,
            share: false,
          },
          link: '',
        };
        this.loadUsers();
        // this.form.contact_id = this.selected_contact.id;
        this.form.conversation_id = this.conversation.id;
      }
    },
  },
  computed: {
    activeWorkspace() {
      return this.$store.state.workspace.activeWorkspace;
    },
  },
  methods: {
    onClose() {
      this.$emit('onClose');
    },
    onSubmit() {
      this.$emit('onSubmit');
    },
    loadUsers() {
      this.searchUser();
    },
    async searchUser(keyword = '') {
      this.filter_users = [];
      this.loading.get_users = true;
      await usersAPI.getList(1, keyword).then((res) => {
        this.filter_users = res.data.rows.map((v) => {
          const x = {
            id: v.id,
            text: `${v.name} (${v.email})`,
          };
          return x;
        });
      }).catch((err) => {
        console.log(err);
      });
      this.loading.get_users = false;
    },
    showLoader() {
      if (this.loaderStack === 0) {
        this.loader = this.$loading.show();
      }
      this.loaderStack += 1;
    },
    hideLoader() {
      this.loaderStack -= 1;
      if (this.loaderStack === 0) {
        this.loader.hide();
      }
    },
    validateForm(ref) {
      this.$refs[ref].validate((valid) => {
        console.log(valid);
        if (!valid) {
          return false;
        }
        this.step = 1;
        return true;
      });
    },
    createVideoCall() {
      if (this.form.conversation_id) {
        this.loading.submit = true;
        this.showLoader();
        videoCallAPI.create({
          workspace_id: this.activeWorkspace._id,
          data: this.form,
        }).then(async (res) => {
          this.hideLoader();
          this.loading.submit = false;
          await popupErrorMessages(res);
          const routeData = this.$router.resolve({ name: 'Meeting Room', params: { meeting_id: res.data.id } });
          console.log(routeData);
          console.log(window.location.origin);
          this.form.link = `${window.location.origin}${routeData.href}`;
          // this.form.link = res.data.link;
          this.$message({
            message: this.$t('video_call.create.success'),
            type: 'success',
          });
          this.step = 2;
        }).catch(async () => {
          this.hideLoader();
          this.loading.submit = false;
        });
      } else {
        this.$message({
          message: this.$t('video_call.create.failed'),
          type: 'error',
        });
        this.onClose();
      }
    },
    copyLink() {
      this.$parent.replyMessage += `*Yth. Bapak/Ibu ${this.conversation?.selected_contact?.name},*\n`;
      this.$parent.replyMessage += 'Berikut adalah link untuk online meeting yang telah dijadwalkan:\n\n';
      this.$parent.replyMessage += `📆 Tanggal: ${moment(this.form.meeting_start).format('dddd, LL')}\n`;
      this.$parent.replyMessage += `🕗 Waktu: ${moment(this.form.meeting_start).format('LT')} s/d ${moment(this.form.meeting_start).add(this.form.duration, 'minutes').format('LT')}\n`;
      this.$parent.replyMessage += `🔗 Link: ${this.form.link}\n\n`;
      this.$parent.replyMessage += 'Silahkan klik tautan di atas untuk bergabung. Jika ada pertanyaan atau kendala, jangan ragu untuk menghubungi kami.\n\nTerima Kasih';
      this.onSubmit();
    },
  },
};
</script>
